import Vue from 'vue';
if(document.getElementById('lector-list')) {
    let lectorList = new Vue({
        el: "#lector-list",
        data: {
            lectors: {},
            page: 1,
            load: false,
            pageCount: 0,
            lectorQuery: '',
            getLectionTime: null
        },
        mounted: function () {
            this.fetchLectors();
        },
        methods: {
            fetchLectors: function (append) {
                var self = this;

                this.load = true;

                try {

                    var data = {full_name: this.lectorQuery};

                    $.extend(data, {page: this.page});

                    $.ajax({
                        url: '/api/v1/lector',
                        dataType: "json",
                        data: data,
                        success: function (data) {
                            if (append === true) {
                                $.each(data.items, function (i, item) {

                                    self.lectors.items.push(item);

                                });

                            } else {

                                self.lectors = data;
                                self.pageCount = data._meta.pageCount;
                                self.page = 1;

                            }
                            self.load = false;

                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {

                    console.error(e);

                }
            },
            search: function () {
                var self = this;

                if (this.lectorQuery.length >= 3 || this.lectorQuery.length === 0) {
                    clearTimeout(this.getLectionTime);

                    this.getLectionTime = setTimeout(
                        self.fetchLectors(),
                        5000
                    );
                }

            },
            nextPage: function () {

                this.page = this.page + 1;
                this.fetchLectors(true);

            }
        }


    });

}